import { Injectable } from "@angular/core";

// Ensures auto-opened create dialogs (see SafetyCardComponent/ActivityCardComponent
// `openEditDialog`) never stack: several new custom cards can render in the same change
// detection pass (e.g. a multi-select picker save), but MatDialog should only ever show one
// at a time. Deferred to a microtask so dialogs never open from inside ngOnChanges itself.
@Injectable({ providedIn: "root" })
export class AutoOpenCardQueueService {
  private queue: Array<() => void> = [];
  private active = false;

  enqueue(trigger: () => void): void {
    this.queue.push(trigger);
    this.pump();
  }

  /** Call once the active dialog has closed, to advance to the next queued one. */
  next(): void {
    this.active = false;
    this.pump();
  }

  private pump(): void {
    if (this.active || this.queue.length === 0) return;
    this.active = true;
    const trigger = this.queue.shift()!;
    Promise.resolve().then(() => trigger());
  }
}
